import stores from "@/stores"

/** 是否已选择过套餐 / 开启过试用期 */
export function hasChosenPlan() {
  return !!stores.UserInfoStore.data.has_chosen_plan
}
